@if (showSpinner) {
  <app-loader> </app-loader>
}
<main class="content-wrapper">
  <div class="user-role-main-wrapper">
    <div class="main-wrraper-header">
      <i class='fa fa-arrow-circle-left' [routerLink]="['/setting']"></i>
      <h5>View User Roles</h5>
    </div>
    <div class="main-wraper-body">
      <table>
        <tr>
          <th>Role Name</th>
          <th>Role Type</th>
          <th>Created By</th>
          <th>Created At</th>
        </tr>
        <tr>
          <td>{{stateRole_name}}</td>
          <td>{{stateRole_type}}</td>
          <td>{{created_by}}</td>
          <td>{{created_date }}</td>
        </tr>
        @if (stateRole_type !== 'Employee') {
          <tr>
            <td colspan="4">
              <table class="nested-table">
                <tr>
                  <th>User Roles</th>
                </tr>
                <tr class="head-tr">
                  <td>Evaluation Management</td>
                  <td>{{selectedEvaluationRole ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Evaluation Type</th>
                        <td>{{slectedEvaluation | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Add</th>
                              <td>{{ selectedEvaluationRole.add ? 'True' : 'False' }}</td>
                              <th>Send Mail</th>
                              <td>{{ selectedEvaluationRole.sendmail ? 'True' : 'False' }}</td>
                              <th>Send Update</th>
                              <td>{{ selectedEvaluationRole.update ? 'True' : 'False' }}</td>
                              <th>Send View</th>
                              <td>{{ selectedEvaluationRole.view ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- team managment -->
                <tr class="head-tr">
                  <td>Team Management</td>
                  <td>{{roleManagment ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{selected | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>User Add</th>
                              <td>{{ selectedRoles.add ? 'True' : 'False' }}</td>
                              <th>User View</th>
                              <td>{{ selectedRoles.view ? 'True' : 'False' }}</td>
                              <th>User Update</th>
                              <td>{{ selectedRoles.updateUser ? 'True' : 'False' }}</td>
                              <th>User Delete</th>
                              <td>{{ selectedRoles.delete ? 'True' : 'False' }}</td>
                              <th>PayRoll Create</th>
                              <td>{{ selectedRoles.create ? 'True' : 'False' }}</td>
                              <th>Monthly Salary</th>
                              <td>{{ selectedRoles.monthly_salary ? 'True' : 'False' }}</td>
                              <th>WHF</th>
                              <td>{{ selectedRoles.update ? 'True' : 'False' }}</td>
                              <th>Loan Accept</th>
                              <td>{{ selectedRoles.loanAccept ? 'True' : 'False' }}</td>
                              <th>Loan Reject</th>
                              <td>{{ selectedRoles.loanReject ? 'True' : 'False' }}</td>
                              <th>Loan View</th>
                              <td>{{ selectedRoles.loanView ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- team Resign -->
                <tr class="head-tr">
                  <td>Team Resign Management</td>
                  <td>{{roleResign ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{resignRoles | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Accept</th>
                              <td>{{ resignMainRoles.accept ? 'True' : 'False' }}</td>
                              <th>User View</th>
                              <td>{{ resignMainRoles.reject ? 'True' : 'False' }}</td>
                              <th>User Update</th>
                              <td>{{ resignMainRoles.view ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- Holdays -->
                <tr class="head-tr">
                  <td>Holidays Management</td>
                  <td>{{holidaysMainRole ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{holidaysMainRole | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Add</th>
                              <td>{{ holidaysSubRoles.add ? 'True' : 'False' }}</td>
                              <th>Delete</th>
                              <td>{{ holidaysSubRoles.delete ? 'True' : 'False' }}</td>
                              <th>Update</th>
                              <td>{{ holidaysSubRoles.update ? 'True' : 'False' }}</td>
                              <th>View</th>
                              <td>{{ holidaysSubRoles.view ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- Media -->
                <tr class="head-tr">
                  <td>Media Management</td>
                  <td>{{roleMedia ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{mediaMainRole | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Accept</th>
                              <td>{{ mediaSubRoles.accept ? 'True' : 'False' }}</td>
                              <th>Reject</th>
                              <td>{{ mediaSubRoles.reject ? 'True' : 'False' }}</td>
                              <th>View</th>
                              <td>{{ mediaSubRoles.view ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- LEave Mangement -->
                <tr class="head-tr">
                  <td>Leave Management</td>
                  <td>{{leaveManagement ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{leaveManagementMainRole | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Accept</th>
                              <td>{{ leaveSubRoles.accept ? 'True' : 'False' }}</td>
                              <th>Reject</th>
                              <td>{{ leaveSubRoles.reject ? 'True' : 'False' }}</td>
                              <th>Update</th>
                              <td>{{ leaveSubRoles.update ? 'True' : 'False' }}</td>
                              <th>View</th>
                              <td>{{ leaveSubRoles.view_leave ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- attedance Mangement -->
                <tr class="head-tr">
                  <td>Attendance Management</td>
                  <td>{{attendanceManagement ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{attendanceMainRole | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Delete</th>
                              <td>{{ attendanceSubRoles.delete ? 'True' : 'False' }}</td>
                              <th>Edit</th>
                              <td>{{ attendanceSubRoles.edit ? 'True' : 'False' }}</td>
                              <th>Report</th>
                              <td>{{ attendanceSubRoles.report ? 'True' : 'False' }}</td>
                              <th>Sheet</th>
                              <td>{{ attendanceSubRoles.sheet ? 'True' : 'False' }}</td>
                              <th>view</th>
                              <td>{{ attendanceSubRoles.view_attedance ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- Event Mangement -->
                <tr class="head-tr">
                  <td>Event Management</td>
                  <td>{{eventManagement ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{eventMainRole | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Add</th>
                              <td>{{ eventSubRoles.add ? 'True' : 'False' }}</td>
                              <th>Delete</th>
                              <td>{{ eventSubRoles.delete ? 'True' : 'False' }}</td>
                              <th>Edit</th>
                              <td>{{ eventSubRoles.edit ? 'True' : 'False' }}</td>
                              <th>View</th>
                              <td>{{ eventSubRoles.view ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- Acounts Mangement -->
                <tr class="head-tr">
                  <td>Acounts Management</td>
                  <td>{{accountManagement ? 'True' : 'False'}}</td>
                </tr>
                <tr class="inner-tabe-main-wraper">
                  <td colspan="2">
                    <table class="iner-nested-table">
                      <tr>
                        <th>Team Type</th>
                        <td>{{accountMainRole | titlecase}}</td>
                      </tr>
                      <tr>
                        <td colspan="2" class="inner-nested-table-main">
                          <table>
                            <tr class="team-managmet-tr">
                              <th>Add</th>
                              <td>{{ accountSubRoles.add ? 'True' : 'False' }}</td>
                              <th>Delete</th>
                              <td>{{ accountSubRoles.delete ? 'True' : 'False' }}</td>
                              <th>Edit</th>
                              <td>{{ accountSubRoles.edit ? 'True' : 'False' }}</td>
                              <th>View</th>
                              <td>{{ accountSubRoles.view ? 'True' : 'False' }}</td>
                              <th>Admin</th>
                              <td>{{ accountSubRoles.admin ? 'True' : 'False' }}</td>
                              <th>Export</th>
                              <td>{{ accountSubRoles.export ? 'True' : 'False' }}</td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        }

      </table>
    </div>
  </div>
</main>